export default __webpack_public_path__ + "static/media/whatsappwhite.ccdf7664.svg";